import styled from 'styled-components';

import logoHover from './logo-hover.png';
import logo from './logo.png';
import cards from './cards.png';
import wow from './wow.png';

export const Padding = styled.div`
	padding: 20px;
`;

interface ISidebarContent {
	alpha?: string | number;
}

export const SidebarContent = styled.div<ISidebarContent>`
	position: relative;
	min-height: 100vh;
`;

export const OpenButton = styled.div`
	position: absolute;
    top: 0;
    right: 0;
    background: #fff;
    padding: 10px;
    z-index: 9001;
    border-bottom-left-radius: 5px;
    border-left: 1px solid #efefef;
    border-bottom: 1px solid #efefef;
    cursor: pointer;
`;

export const SidebarHeader = styled.div`
	padding: 15px;
	font-size: 30px;
	text-align: center;
	display: flex;
    align-items: center;
    justify-content: space-between;
`;

export const ChangesCont = styled.div`
	background: rgba(0, 0, 0, 0.4);
	padding: 15px;
	display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 15px 0px;
`;

export const Controls = styled.div<{editActive: boolean}>`
	position: fixed;
    left: 50%;
	transform: translate(-50%, 0);
	top: 0;
	background: rgb(26,30,32);
    border-radius: 0 0 5px 5px;
    padding: 7px 15px;
    min-width: 250px;
	display: flex;
	justify-content: space-between;
	align-items: center;
	z-index: 9001;

	/* &:hover {
		padding-bottom: 18px;
	}

	${({editActive}) => editActive && `
		height: 40px;
	`} */
`;

export const Logo = styled.div`
	background-image: url(${logo});
	background-size: contain;
    height: 20px;
    width: 35px;
	background-repeat: no-repeat;
	margin-right: 5px;
	display: inline-block;
	cursor: pointer;
	transition: background-image 0.5s ease-in-out;

	&:hover {
		background-image: url(${logoHover});
	}
`;
export const Cards = styled.div`
	background-image: url(${cards});
	background-size: contain;
    height: 15px;
    width: 100px;
	background-repeat: no-repeat;
	margin: 5px;
	display: inline-block;
	cursor: pointer;
	transition: background-image 0.5s ease-in-out;
`;

export const Handel = styled.div`
	top: 50%;
    position: absolute;
    height: 30px;
    width: 30px;
    background: rgb(26,30,32);
	border-radius: 30px;
	transform: translate(-50%, 50%);
	z-index: 9002;
	display: flex;
    align-items: center;
	justify-content: center;

	.sidebar-left & {
		right: -33px;
	}

	.sidebar-right & {
		left: -2px;
	}
`;

export const LeftScrollbars = styled.div`
	position: absolute;
    width: 6px;
    left: 2px;
    bottom: 2px;
    top: 2px;
    border-radius: 3px;
`;

export const WowIcon = styled.div`
	background: url(${wow});
	background-size: contain;
	background-repeat: no-repeat;
	height: 20px;
	width: 20px;
`;


const HrHeading = styled.div`
	display: grid;
	grid-template: "left right" / auto 1fr;
	align-items: center;
	margin: 25px 0px 18px 0px;
	opacity: 0.50;
	
	&:first-child {
		margin-top: 0;
	}
	
	.title {
		font-size: 10px;
		text-transform: uppercase;
		font-weight: bold;
		padding-right: 5px;
		grid-area: left;
	}

	.hr {
		height: 1px;
		background: #ccc;
		grid-area: right;
	}
`;

export const SectionHeading: React.SFC<{title: string}> = ({title}) => (
	<HrHeading>
		<div className="title">{title}</div>
		<div className="hr"></div>
	</HrHeading>
);



// WEBPACK FOOTER //
// ./src/core/components/editor/styled/fragments.tsx